import React, { Fragment, useState } from "react";
import { ViedocDialogElement } from "../../../../../secure/elements/ViedocReactElements";
import { t } from "i18next";
import { useSelector, useDispatch } from "react-redux";
import * as UtilsHelper from "../../../../../../utils/utilsHelper";
import Loader from "../../../shared/Loader/Loader";
import DownloadOptions from "./DownloadOptions";
import * as documentActions from "../../../../../store/actions/documentActions";
import _ from "underscore";

const BinderDetailViewRender = ({
  setShowBinderProperties,
  fileDetailsHeaderElement,
  docDetailsList,
  closeSharingDialog,
}) => {
  const dispatch = useDispatch();

  const { userList } = useSelector((state) => state.zone);
  const { downLoader } = useSelector((store) => store.file);
  const {
    bindersHistoryDetail,
    bindersSpinner,
    binderDetails,
    isBindersLoader,
    isBinderDetail,
    isBindersCallRunning,
    binderListIds,
    isBinderRecalling,
    lastbindercreatedon,
    existingUsersList,
    documentVersionList,
    downloadSignatureLoader,
  } = useSelector((state) => state.document);

  let currentId = binderListIds.find(
    (item) => item.binderId === binderDetails?.binderId
  )?.binderId;

  let currentIndex = binderListIds.findIndex(
    (list) => list.binderId === currentId
  );

  const { fullDateTimePattern, dateLocale } = useSelector(
    (store) => store.template
  );

  const [showDownloadOptions, setShowDownloadOptions] = useState(false);

  const finalCloseSharingDialog = (e) => {
    dispatch({ type: "MAKE_BINDER_LIST_VISIBLE" });
    dispatch(documentActions.reCallBinderFailed());
    dispatch(documentActions.showBinderDetailPage(false));
    setShowBinderProperties(false);
    closeSharingDialog(e);
  };

  const onHide = (e) => {
    e.stopPropagation();
    setShowBinderProperties(false);
    dispatch(documentActions.reCallBinderFailed());
    dispatch(documentActions.showBinderDetailPage(false));
    if (isBinderDetail) {
      if (!isBindersCallRunning) {
        const reqPayload = {
          documentid: docDetailsList.documentid,
          isForceDataGet: false,
          lastModifiedOn: lastbindercreatedon,
        };
        dispatch(
          documentActions.getExistingSharedUsersList(
            reqPayload,
            existingUsersList,
            docDetailsList.documentversionguid,
            "binderProperty"
          )
        );
      }
    }
  };

  const checkTranslateKeyExist = (value) => {
    return UtilsHelper.getSignReasonTranslateKey(value);
  };

  const getStatusIcon = () => {
    switch (binderDetails.sharingStatus) {
      case "Pending":
        return "load";
      case "Recalled":
        return "block";
      case "Done":
        return "check";
      default:
        break;
    }
  };

  const getStatusBackground = () => {
    switch (binderDetails.sharingStatus) {
      case "Done":
        return "#008726";
      default:
        return "#e0e0e0";
    }
  };

  const renderBinderBasicInfo = () => {
    return (
      <div className="binder-text-info">
        <div className="binder-basic">
          <div className="gen-info">
            <p>
              {`${t("TMF.LABEL_BINDERID")}: `}
              <span className="sem-pri-color mr-15">
                {binderDetails.binderId}
              </span>
            </p>
            <span>|</span>
            <p>
              {`${t("TMF.LABEL_DOCUMENTVERSION")}: `}
              <span className="sem-pri-color mr-15">
                {!_.isEmpty(documentVersionList)
                  ? documentVersionList?.filter(
                      (latest) => latest.islatestdocumentversion === true
                    )[0].documentversionnumber
                  : ""}
              </span>
            </p>
          </div>
          <div className="gen-info">
            <p>
              {`${t("TMF.LABEL_VIEWED")}: `}{" "}
              <span className="sem-pri-color mr-15">
                {binderDetails.viewedCount}
              </span>
            </p>
            <span>|</span>
            <p>
              {`${t("TMF.LABEL_SIGNED")}: `}
              <span className="sem-pri-color mr-15">
                {binderDetails.signedCount}
              </span>
            </p>
          </div>
          <div className="gen-info">
            <p>
              {`${t("TMF.TEXT_BINDERSCREATED")}: `}
              <span className="sem-pri-color mr-15">
                {fullDateTimePattern
                  ? UtilsHelper.getFormattedDateTime(
                      fullDateTimePattern,
                      binderDetails.binderCreatedOn,
                      dateLocale
                    )
                  : UtilsHelper.momentLocalConversion(
                      binderDetails.binderCreatedOn,
                      true
                    )}
              </span>
            </p>
            <span>|</span>
            <p>
              {`${t("TMF.TEXT_CREATEDBY")}: `}
              <span className="sem-pri-color mr-15">
                {UtilsHelper.findUserName(
                  userList,
                  binderDetails.binderCreatedBy
                )}
              </span>
            </p>
          </div>
        </div>
        {binderDetails.isRecalled && renderBasicRevokedInfo()}
        {renderBasicRecipientInfo()}
        {binderDetails.requiredSignature &&
          binderDetails.coSignatoriesCount > 0 &&
          renderBasicCoSignatoryInfo()}
      </div>
    );
  };

  const renderBasicRevokedInfo = () => {
    return (
      <div className="binder-basic">
        <div className="gen-info f14" style={{ color: "#e52800" }}>
          {t("TMF.TEXT_REVOKED")}
        </div>
        <div className="gen-info">
          <p>
            {`${t("TMF.TEXT_BINDERREVOKED")}: `}
            <span className="sem-pri-color mr-15">
              {fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    binderDetails.recalledDateTime,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(
                    binderDetails.recalledDateTime,
                    true
                  )}
            </span>
          </p>
          <span>|</span>
          <p>
            {`${t("TMF.TEXT_REVOKEDBY")}: `}
            <span className="sem-pri-color mr-15">
              {UtilsHelper.findUserName(userList, binderDetails?.recalledBy)}
            </span>
          </p>
        </div>
      </div>
    );
  };

  const renderBasicRecipientInfo = () => {
    return (
      <div className="binder-basic">
        <div className="gen-info">
          <p>
            {`${t("TMF.TEXT_HASHOFRECIPIENT")}: `}
            <span className="sem-pri-color mr-15">
              {binderDetails.recipientsCount}
            </span>
          </p>
          <span>|</span>
          <p>
            {`${t("TMF.TEXT_SIGNATUREREQUIRED")}: `}
            <span className="sem-pri-color mr-15">
              {binderDetails.requiredSignature
                ? t("ADMIN.DELETEDOCUMENT_YES")
                : t("ADMIN.DELETEDOCUMENT_NO")}
            </span>
          </p>
        </div>
        {binderDetails.requiredSignature && (
          <div className="gen-info flex-dir-col gap-5">
            <p>{`${t("TMF.TEXT_REASONFORSIGNATURE")}:`}</p>
            <p className="sem-pri-color mr-15">
              {checkTranslateKeyExist(binderDetails.signatureReason)
                ? t(
                    `TMF.${checkTranslateKeyExist(
                      binderDetails.signatureReason
                    )}`
                  )
                : binderDetails.signatureReason}
            </p>
          </div>
        )}
      </div>
    );
  };

  const renderBasicCoSignatoryInfo = () => {
    return (
      <div className="binder-basic">
        <div className="gen-info">
          <p>
            {`${t("TMF.TEXT_HASHOFCOSIGNATORY")}: `}
            <span className="sem-pri-color mr-15">
              {binderDetails.coSignatoriesCount}
            </span>
          </p>
        </div>
        <div className="gen-info flex-dir-col gap-5">
          <p>{`${t("TMF.TEXT_REASONFORCOSIGNATURE")}:`}</p>
          <p className="sem-pri-color mr-15">
            {checkTranslateKeyExist(binderDetails.coSingnatorySignatureReason)
              ? t(
                  `TMF.${checkTranslateKeyExist(
                    binderDetails.coSingnatorySignatureReason
                  )}`
                )
              : binderDetails.coSingnatorySignatureReason}
          </p>
        </div>
      </div>
    );
  };

  const renderRecipientData = () => {
    return binderDetails.recipientsDetailsList?.map((recipient, index) => (
      <div
        className="recipient-data"
        key={index}
        style={{
          borderBottom:
            binderDetails.recipientsDetailsList.length - 1 !== index
              ? "1px solid #f0eaea"
              : "",
        }}
      >
        <div>{recipient.displayName ? recipient.displayName : recipient.userId}</div>
        <div>
          {fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                recipient.sharedDate,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(recipient.sharedDate, true)}
        </div>
        <div>
          {recipient.viewedDate
            ? fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  recipient.viewedDate,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(recipient.viewedDate, true)
            : "-"}
        </div>
        <div>
          {recipient.signedDate
            ? fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  recipient.signedDate,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(recipient.signedDate, true)
            : "-"}
        </div>
        <div
          className="recipient-status"
          style={{
            background: binderDetails.isRecalled
              ? "#e0e0e0"
              : recipient.isCompleted
              ? "#008726"
              : "#e0e0e0",
          }}
        >
          <viedoc-icon
            name={
              binderDetails.isRecalled
                ? "block"
                : recipient.isCompleted
                ? "check"
                : "load"
            }
          />
        </div>
      </div>
    ));
  };

  const renderRecipientList = () => {
    return (
      <div className="recipient-list">
        <div className="recipient-header">
          <div>
            {t("TMF.LABEL_RECIPIENTS")}
            <p>|</p>
          </div>
          <div>
            {t("TMF.LABEL_SHAREDDATE")}
            <p>|</p>
          </div>
          <div>
            {t("TMF.LABEL_VIEWEDDATE")}
            <p>|</p>
          </div>
          <div>
            {t("TMF.LABEL_SIGNEDDATE")}
            <p>|</p>
          </div>
          <div>{t("TMF.LABEL_STATUS")}</div>
        </div>
        {renderRecipientData()}
      </div>
    );
  };

  const renderCoSignatoryData = () => {
    return binderDetails.coSignatoriesDetailsList?.map((recipient, index) => (
      <div
        className="recipient-data"
        key={index}
        style={{
          borderBottom:
            binderDetails.coSignatoriesDetailsList.length - 1 !== index
              ? "1px solid #f0eaea"
              : "",
        }}
      >
        <div>{recipient.displayName ? recipient.displayName : recipient.userId}</div>
        <div>
          {fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                recipient.sharedDate,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(recipient.sharedDate, true)}
        </div>
        <div>
          {recipient.viewedDate
            ? fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  recipient.viewedDate,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(recipient.viewedDate, true)
            : "-"}
        </div>
        <div>
          {recipient.signedDate
            ? fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  recipient.signedDate,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(recipient.signedDate, true)
            : "-"}
        </div>
        <div
          className="recipient-status"
          style={{ background: recipient.isCompleted ? "#008726" : "#e0e0e0" }}
        >
          <viedoc-icon
            name={
              binderDetails.isRecalled
                ? "block"
                : recipient.isCompleted
                ? "check"
                : "load"
            }
          />
        </div>
      </div>
    ));
  };

  const renderCoSignatoryList = () => {
    return (
      <div className="recipient-list">
        <div className="recipient-header">
          <div>
            {t("TMF.LABEL_COSIGNATORY")}
            <p>|</p>
          </div>
          <div>
            {t("TMF.LABEL_SHAREDDATE")}
            <p>|</p>
          </div>
          <div>
            {t("TMF.LABEL_VIEWEDDATE")}
            <p>|</p>
          </div>
          <div>
            {t("TMF.LABEL_SIGNEDDATE")}
            <p>|</p>
          </div>
          <div>{t("TMF.LABEL_STATUS")}</div>
        </div>
        {renderCoSignatoryData()}
      </div>
    );
  };

  const renderBinderPropertiesSection = () => {
    return (
      <div className="binder-props">
        <div className="binder-info">
          <div
            className="status-icon"
            style={{ background: getStatusBackground() }}
          >
            <viedoc-icon name={getStatusIcon()} />
          </div>
          {renderBinderBasicInfo()}
        </div>
        {renderRecipientList()}
        {binderDetails.coSignatoriesCount > 0 && renderCoSignatoryList()}
      </div>
    );
  };

  const binderHistoryUserName = (history) => {
    return history.username ? history.username : history.userid
  }

  const renderbinderHistory = (
    history,
    historyTextStatus,
    downloadNoteHistory
  ) => {
    return (
      <p className="history-view">
        {`${t("COMMON.TEXT_DOCUMENT")} ${
          !downloadNoteHistory ? t("TMF.TEXT_DOCUMENTSNOTES") : ""
        } ${historyTextStatus} ${t("TMF.TEXT_ON")} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                history.createdon,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(history.createdon, true)
        } ${t("TMF.TEXT_BY")} ${binderHistoryUserName(history)} `}
      </p>
    );
  };

  const renderHistoryList = (history) => {
    switch (history.status) {
      case "shared":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_ARECORD")} ${t("TMF.TEXT_WASSHARED")} ${t(
              "TMF.TEXT_WITH"
            )} ${history.recipientcount} ${
              history.recipientcount === 1
                ? t("TMF.TEXT_RECIPIENT")
                : t("TMF.TEXT_LOWEERCASERECIPIENTS")
            } ${
              history.cosignatorycount > 0
                ? `${t("TMF.TEXT_AND")} ${history.cosignatorycount} ${
                    history.cosignatorycount > 1
                      ? t("TMF.TEXT_PLURALCOSIGN")
                      : t("TMF.TEXT_SINGULARCOSIGN")
                  }`
                : ""
            } ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    history.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(history.createdon, true)
            } ${t("TMF.TEXT_BY")} ${binderHistoryUserName(history)}`}
          </p>
        );

      case "viewed":
        return (
          <p className="history-view">
            {`${t("COMMON.TEXT_DOCUMENT")} ${t("TMF.TEXT_VIEWED")} ${t(
              "TMF.TEXT_ON"
            )} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    history.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(history.createdon, true)
            } ${t("TMF.TEXT_BY")} ${binderHistoryUserName(history)}`}
          </p>
        );

      case "signed":
        return (
          <p className="history-view">
            {`${binderHistoryUserName(history)} ${t("TMF.TEXT_SIGNEDWITH")} ${t(
              "TMF.TEXT_ON"
            )} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    history.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(history.createdon, true)
            } ${t("TMF.TEXT_WITHREASON")} "${t(
              `TMF.${UtilsHelper.getSignReasonTranslateKey(history.reason)}`
            )}"`}
          </p>
        );

      case "SharingRecalled":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_SHARINGREVOKED")} ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    history.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(history.createdon, true)
            } ${t("TMF.TEXT_BY")} ${binderHistoryUserName(history)}`}
          </p>
        );

      case "downloaded":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_ORIGINALFILEDOWNLOADED")} ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    history.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(history.createdon, true)
            } ${t("TMF.TEXT_BY")} ${binderHistoryUserName(history)}`}
          </p>
        );

      case "downloadsharingdetails":
        return (
          <p className="history-view">{`${t("COMMON.TEXT_DOCUMENT")} ${t(
            "TMF.TEXT_DOWNLOADEDWITHSHARING"
          )} ${t("TMF.TEXT_ON")} ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  history.createdon,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(history.createdon, true)
          } ${t("TMF.TEXT_BY")} ${binderHistoryUserName(history)}`}</p>
        );

      case "downloadwithsignature":
        return (
          <p className="history-view">{`${t("COMMON.TEXT_DOCUMENT")} ${t(
            "TMF.TEXT_DOWNLOADEDSIGNATURE"
          )} ${t("TMF.TEXT_ON")} ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  history.createdon,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(history.createdon, true)
          } ${t("TMF.TEXT_BY")} ${binderHistoryUserName(history)}`}</p>
        );

      case "notesadded":
        return renderbinderHistory(history, t("TMF.TEXT_DOCUMENTADDED"));
      case "notesupdated":
        return renderbinderHistory(history, t("TMF.TEXT_DOCUMENTUPDATED"));
      case "notesdeleted":
        return renderbinderHistory(history, t("TMF.TEXT_DOCUMENTDELETED"));
      case "downloadwithnotes":
        return renderbinderHistory(
          history,
          t("TMF.TEXT_DOWNLOADEDNOTES"),
          true
        );

      default:
        break;
    }
  };

  const renderHistorySection = () => {
    return (
      <div
        className={`binder-history ${
          bindersSpinner ? "jc-center align-center" : ""
        }`}
      >
        {bindersSpinner ? (
          <viedoc-spinner />
        ) : (
          <>
            <div className="history-header">
              <viedoc-badge variant="neutral">
                {t("TMF.TEXT_HISTORY")}
              </viedoc-badge>
            </div>
            <div className="history-list">
              {bindersHistoryDetail.map((fieldvalue, index) => (
                <Fragment key={index}>{renderHistoryList(fieldvalue)}</Fragment>
              ))}
            </div>
          </>
        )}
      </div>
    );
  };

  const previousBinderHandler = () => {
    binderListIds[currentIndex - 1]?.sharingBinderId &&
      dispatch(
        documentActions.getBindersDetail(
          binderListIds[currentIndex - 1].sharingBinderId
        )
      );
    binderListIds[currentIndex - 1]?.sharingBinderId &&
      dispatch(
        documentActions.getBindersHistory(
          binderListIds[currentIndex - 1].sharingBinderId
        )
      );
  };

  const nextBinderHandler = () => {
    binderListIds[currentIndex + 1]?.sharingBinderId &&
      dispatch(
        documentActions.getBindersDetail(
          binderListIds[currentIndex + 1].sharingBinderId
        )
      );
    binderListIds[currentIndex + 1]?.sharingBinderId &&
      dispatch(
        documentActions.getBindersHistory(
          binderListIds[currentIndex + 1].sharingBinderId
        )
      );
  };

  return (
    <ViedocDialogElement
      id="doc-view-popup"
      size="large"
      open
      preventCloseByClick
      onHide={(e) => finalCloseSharingDialog(e)}
      className="documentSharingView"
    >
      {isBindersLoader ? (
        <Loader borderRadius width={"100%"} height={"200px"} />
      ) : (
        <>
          <header slot="header">
            <div className="document-header pl-10 mr-10 sharing-doc-header">
              <viedoc-icon name="sharing" />
              {t("TMF.TEXT_FILESHARING")}
            </div>
          </header>
          {fileDetailsHeaderElement(false)}
          <div className="binder-prop-main-container">
            <div className="d-flex jc-space-btw align-center">
              <div
                className="back-icon"
                onClick={(e) => onHide(e)}
                title={t("TMF.BUTTON_BACK")}
              >
                <viedoc-icon name="arrow" />
              </div>
              <div className="binder-navigation">
                <div
                  className="previous-icon"
                  title={
                    currentIndex === 0
                      ? t("TMF.TEXT_NOPREVIOUSBINDER")
                      : t("TMF.TEXT_PREVIOUS")
                  }
                  style={{
                    cursor: currentIndex === 0 ? "not-allowed" : "pointer",
                  }}
                >
                  <viedoc-icon
                    name="expand"
                    class={currentIndex === 0 ? "disable-pervious" : ""}
                    onClick={() => previousBinderHandler()}
                  />
                </div>
                <div className="mt-3">
                  <h2 className="f21">{`${t("TMF.LABEL_BINDERID")}: ${
                    binderDetails.binderId
                  }`}</h2>
                </div>
                <div
                  className="previous-icon"
                  title={
                    currentIndex === binderListIds.length - 1
                      ? t("TMF.TEXT_NONEXTBINDER")
                      : t("TMF.TEXT_NEXT")
                  }
                  style={{
                    transform: "rotate(-90deg)",
                    cursor:
                      currentIndex === binderListIds.length - 1
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  <viedoc-icon
                    name="expand"
                    class={
                      currentIndex === binderListIds.length - 1
                        ? "disable-pervious"
                        : ""
                    }
                    onClick={() => nextBinderHandler()}
                  />
                </div>
              </div>
              <div className="detail-binder-download">
                {downLoader || isBinderRecalling || downloadSignatureLoader ? (
                  <viedoc-spinner size="small" class="spinner"></viedoc-spinner>
                ) : (
                  <button
                    className="download-icon"
                    onClick={() =>
                      setShowDownloadOptions((prevState) => !prevState)
                    }
                  >
                    <span>...</span>
                  </button>
                )}
                {showDownloadOptions && (
                  <DownloadOptions
                    isBinderProperties={true}
                    docDetailsList={docDetailsList}
                    setShowDownloadOptions={setShowDownloadOptions}
                    showDownloadOptions={showDownloadOptions}
                  />
                )}
              </div>
            </div>
            {renderBinderPropertiesSection()}
            {renderHistorySection()}
          </div>
        </>
      )}
      <footer slot="footer"></footer>
    </ViedocDialogElement>
  );
};

export default BinderDetailViewRender;
